(function($) {
	$.fn.refresh = function() {
		var elems = $(this.selector);
		this.splice(0, this.length);
		this.push.apply( this, elems );
		return this;
	};
		
	$.fn.ob_loading = function() {
			var select = this;
			if (select.css('position') == 'static' ){
				select.css('position','relative');
			}
			if (!select.children('.loading_overlay').length ){
				select.prepend('<div class="loading_overlay">\
											<div class="loading_content">\
												<div class="loading_text"></div>\
											</div>\
										</div>');
				
			}
			if ( select.is( "body" ) ) {
				select.find('.loading_overlay').addClass( "full" );
			}
	
	};
	
	$.fn.ob_stop_loading = function() {
			//this.children('.loading_overlay').remove();
			$('.loading_overlay').remove();
	};
	
	$.fn.exist = function() {
		return this.length
	};
	
	$.fn.inView = function(options) {
		var $el = $(this);
			
		var defaultOptions = {
				type : 'partial',  //full or partial
		};

		var options = $.extend({}, defaultOptions, options);
		
		var top_of_element = $el.offset().top;
		var bottom_of_element = $el.offset().top + $el.outerHeight();
		var bottom_of_screen = $(window).scrollTop() + $(window).height();
		var top_of_screen = $(window).scrollTop();
		
		if (options.type == 'full'){ //element is fully visible
			//console.log(top_of_screen+ ' < '+ top_of_element + ' ' + bottom_of_screen + ' > '+ bottom_of_element );
			if ((top_of_screen < top_of_element) && (bottom_of_screen > bottom_of_element)){
					return true;
			}else {
					return false;
			}
			
		}else{ //element is partially visible
			if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
				return true;
			}else {
					return false;
			}
		}
		
	};
	
	$.fn.full_width = function() {
		this.each(function(){

			var $el = $(this);
			var window_width = $(window).outerWidth(true);
			var is_absolute = ( $el.css("position") ===  'absolute'? true: false);
			var $parent = ( is_absolute ? $el.offsetParent(): $el.parent());
	
			var parent_width = $parent.innerWidth();
			var parent_width_padding = ( is_absolute ? 0 : parseInt($parent.css('padding-left')) );
			
			var left = '-'+( (window_width - parent_width ) / 2 + parent_width_padding  )+'px' ;

			$el.css({
				'width' : window_width,
				'left' : left,
			});
			
			if ($el.css('position') == 'static'){
				$el.css({
					'position' : 'relative',
				})
			}
		});
		
		return this;
	};
	
	
	//Copy to clipboard
	$.fn.to_clipboard = function() {

		$(this).click(function(e){
			e.preventDefault();
			var target = $(this).attr('target');
			var $target = $(target);
			var copydeck = $('<textarea id="copy_temp" style="position:absolute;opacity:0;top:0;left:0;">'+$target.html()+'</textarea>'); //cant use display none to copy
			$('body').prepend(copydeck);
			copydeck[0].select();
			document.execCommand("copy");
			copydeck.remove();
		});
		return this;
	};
	
	/*
	//perfectly crop text for ellipsis
	$.fn.ellipsis = function(options) {
		var $el = $(this);
		var el_height = $el.height();
		
		//reset
		$el.find('.text_ellipsis').remove();
		$el[0].style.height = null;
		
		//options
		var defaultOptions = {
				dots : true,  //add dots if cropped
				max_height : el_height,  //div  height
		};
		var options = $.extend({}, defaultOptions, options);
		//core
		
		var line_height = parseFloat($el.css('line-height'));
		var max_nb_line = parseInt(options.max_height /  line_height);
		var new_height = max_nb_line * line_height;
		var is_overflowed = (el_height + 1)  >= new_height; //+1 in case half pixel issue
		console.log('----------------');
		console.log($el.css('background-color')) ;
		
		//$el.height(new_height);
		$el.css('max-height', new_height);
		
		//add dots
		if (is_overflowed && options.dots){
			if ($el.css('position') == 'static'){$el.css('position', 'relative');}
			$el.append('<div class="text_ellipsis" style="'+$el.css('background-color')+'" >...</div>');
		}
		
		
		return this;
		
	};*/
	



}(jQuery));



function get_url_arg(){
	// This function is anonymous, is executed immediately and 
	// the return value is assigned to QueryString!
	var query_string = {};
	var query = window.location.search.substring(1);
	var vars = query.split("&");
	for (var i=0;i<vars.length;i++) {
		var pair = vars[i].split("=");
		if (pair == ''){continue;}
		// If first entry with this name
		if (typeof query_string[pair[0]] === "undefined") {
			query_string[pair[0]] = decodeURIComponent(pair[1]);
		// If second entry with this name
		} else if (typeof query_string[pair[0]] === "string") {
			var arr = [ query_string[pair[0]],decodeURIComponent(pair[1]) ];
			query_string[pair[0]] = arr;
			// If third or later entry with this name
		} else {
			query_string[pair[0]].push(decodeURIComponent(pair[1]));
		}
	} 
	return query_string;

}

function replaceUrlParam(url, paramName, paramValue){
	if(paramValue == null)
		paramValue = '';
	var pattern = new RegExp('\\b('+paramName+'=).*?(&|$)')
	if(url.search(pattern)>=0){
		return url.replace(pattern,'$1' + paramValue + '$2');
	}
	return url + (url.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue 
}
function removeUrlParam(url, paramName){
	var pattern = new RegExp('\\b('+paramName+'=).*?(&|$)')
	if(url.search(pattern)>=0){
		return url.replace(pattern,'');
	}
	return url + (url.indexOf('?')>0 ? '&' : '?') ;
}

function createCookie(name, value, days) {
    var expires;

    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
}

function readCookie(name) {
    var nameEQ = encodeURIComponent(name) + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ')
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
            return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
}

function eraseCookie(name) {
    createCookie(name, "", -1);
}
